import { Component, Inject, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from '../../../../../../notification/shared/notification.service'
import { Client } from '../../../../../shared/client/client'
import { Lingerie } from '../../shared/lingerie'
import { LingerieService } from '../../shared/lingerie.service'

@Component({
  selector: 'app-activate-lingerie-modal',
  templateUrl: './activate-lingerie-modal.component.html',
  styleUrls: [
    './activate-lingerie-modal.component.scss'
  ]
})
export class ActivateLingerieModalComponent implements OnInit {

  public form = new UntypedFormGroup({
    lingerie: new UntypedFormControl('', [Validators.required])
  })

  public lingeries: Lingerie[] = null
  client: Client

  constructor(
    public dialogRef: MatDialogRef<ActivateLingerieModalComponent>,
    private route: ActivatedRoute,
    private lingerieService: LingerieService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: Client,
  ) { }

  ngOnInit(): void {
    this.client = this.data;
    this.lingerieService.getLingeriesClientDeactivated(this.client.id).subscribe(data => {
      if (data.length > 0) {
        this.lingeries = data.sort((a, b) => a.libelle > b.libelle ? 1 : -1)
      } else {
        this.notificationService.notif("Aucune lingerie n'est désactivée pour ce client", "notif")
        this.dialogRef.close()
      }
    })
  }

  onSubmit() {
    if (this.form.valid) {
      let listLingeries = []
      if (this.lingeries.length == 1) {
        listLingeries.push(this.lingeries[0])
      } else {
        this.form.value.lingerie.forEach(lingerieId => {
          listLingeries.push(this.lingeries.find(value => value.id == lingerieId))
        })
      }

      let datas = { lingeries: listLingeries }
      this.lingerieService.activateLingerieClient(this.client.id, datas).subscribe((lingerie) => {
        if (listLingeries.length == 1) {
          this.notificationService.notif("La lingerie '" + listLingeries[0].libelle + "' a été réactivée", "notif")
        } else {
          let textLingeries = ""
          listLingeries.forEach(lingerie => {
            if (textLingeries) {
              textLingeries += ", '" + lingerie.libelle + "'"
            } else {
              textLingeries = "'" + lingerie.libelle + "'"
            }

            this.notificationService.notif("Les lingeries (" + textLingeries + ") ont été réactivées", "notif")
          })
        }
        this.dialogRef.close(this.form.value.lingerie)
      })
    }
  }

  refuse() {
    this.dialogRef.close(false)
  }
}